/**
 * Every message namespace loaded per locale — one entry per file in
 * `messages/<locale>/`. Lives here rather than in `request.ts` so client code
 * can use it too: the keys-mode hover inspector validates that a dotted token
 * on screen is an actual translation key (`common.save`) and not an email
 * address, filename, or URL that happens to contain a dot.
 *
 * `tests/unit/keys-mode-hover.test.ts` fails if this drifts from the folder.
 */
export const MESSAGE_NAMESPACES = [
  'common',
  'auth',
  'navigation',
  'dashboard',
  'validation',
  'roles',
  'users',
  'adminOnboarding',
  'containerTypes',
  'profile',
  'dynamicForms',
  'registration',
  'systemLogs',
  'sticking',
  'review',
  'container',
  'packing',
  'boxes',
  'boxTypes',
  'shipping',
  'notifications',
  'reception',
  'devices',
  'handoverScanning',
  'photoScanning',
  'qrReview',
  'qrOverlay',
  'sorting',
  'repairs',
  'paperCamera',
  'storageLocations',
  'shelves',
  'clients',
  'warehouseAssignment',
  'warehouse',
  'globalScanner',
  'security',
  'configurations',
  'aiModels',
  'drivers',
  'repairSettings',
  'supervisor',
  'ocrTemplates',
  'ocr',
  'ocrQa',
  'discoveredFields',
  'devTools',
  'localization',
  'search',
  'license'
] as const;

export type MessageNamespace = (typeof MESSAGE_NAMESPACES)[number];

const NAMESPACE_SET: ReadonlySet<string> = new Set(MESSAGE_NAMESPACES);

/** True when `value` is one of the loaded namespaces. */
export function isMessageNamespace(value: string): boolean {
  return NAMESPACE_SET.has(value);
}
